class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');
    this.changeVersion = 0;

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      const onInput = debounce((event, version) => {
        if (version === this.changeVersion && !event.isComposing) this.onChange(event);
      }, 300);
      this.input.addEventListener('input', event => {
        this.toggleResetButton();
        onInput(event, ++this.changeVersion);
      });
    }
  }

  cancelPendingChange() {
    this.changeVersion += 1;
  }

  disconnectedCallback() {
    this.cancelPendingChange();
  }

  toggleResetButton() {
    if (!this.resetButton) return;
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return true;
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.cancelPendingChange();
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
